"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimelineCardV2 = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSvg = require("react-svg");
var _ButtonGroup = require("../ButtonGroup");
var _RichText = require("../RichText");
var _Milestone = require("./Milestone");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _useTracking2 = require("../../hooks/useTracking");
var _LocaleProvider = require("../LocaleProvider");
var _arrow_down_orange = _interopRequireDefault(require("../../assets/images/arrow_down_orange.svg"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('timeline-card-v2');
var TimelineCardV2 = function TimelineCardV2(props) {
  var title = props.title,
    milestones = props.milestones,
    buttonGroup = props.buttonGroup,
    disabled = props.disabled,
    previewMockData = props.previewMockData,
    shouldHandleDateVariable = props.shouldHandleDateVariable;
  var ref = (0, _react.useRef)(null);
  var hasActionButton = buttonGroup != null && buttonGroup.buttons.length > 0;
  var defaultMilestoneShowCount = computeDefaultMilestoneShowCount(milestones);
  var canCollapse = defaultMilestoneShowCount < milestones.length;
  var _useState = (0, _react.useState)(defaultMilestoneShowCount < milestones.length),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var firstFutureIndex = milestones.findIndex(function (milestone) {
    return milestone.isFuture;
  });
  var currentIndex = firstFutureIndex !== -1 ? firstFutureIndex - 1 : milestones.length - 1;
  var showMilestones = !isCollapsed ? milestones : milestones.slice(0, defaultMilestoneShowCount);
  var _useTracking = (0, _useTracking2.useTracking)(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var showMoreText = trans('chatbot_taskflow_timeline_showmore') || 'Show more';
  var showLessText = trans('chatbot_taskflow_timeline_showless') || 'Show less';
  var handleCollapse = function handleCollapse() {
    setIsCollapsed(!isCollapsed); // 点击埋点

    trackingClick && tracker.click(trackingClick);
  };
  var handleVariableShow = function handleVariableShow() {
    var _ref$current;
    var variableDom = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll(".".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS));
    if (variableDom !== null && variableDom !== void 0 && variableDom.length) {
      (0, _RichText.getShowCustomVariable)(variableDom)();
    }
  };
  var handleVariableHide = function handleVariableHide() {
    var _ref$current2;
    var variableDom = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.querySelectorAll(".".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS));
    if (variableDom !== null && variableDom !== void 0 && variableDom.length) {
      (0, _RichText.getHideCustomVariable)(variableDom)();
    }
  };
  var richtextProps = {
    previewMockData: previewMockData,
    shouldHandleDateVariable: shouldHandleDateVariable,
    handleVariableShow: handleVariableShow,
    handleVariableHide: handleVariableHide
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: PREFIX,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_RichText.RichText, (0, _extends2.default)({}, title, {
    className: "".concat(PREFIX, "-content"),
    disableSpecialLink: disabled
  }, richtextProps)), /*#__PURE__*/_react.default.createElement(_Milestone.Milestone, (0, _extends2.default)({
    milestones: showMilestones,
    isCollapsed: isCollapsed,
    currentIndex: currentIndex,
    disabled: disabled
  }, richtextProps)), canCollapse && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)("".concat(PREFIX, "-expand-collapse"))
  }, trackingImpressionProps, {
    onClick: handleCollapse
  }), /*#__PURE__*/_react.default.createElement("span", null, isCollapsed ? showMoreText : showLessText), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _arrow_down_orange.default,
    className: "".concat(PREFIX, "-arrow-icon"),
    style: {
      transform: "rotate(".concat(isCollapsed ? '0' : '180deg', ")")
    }
  })), hasActionButton && /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, (0, _extends2.default)({
    className: "".concat(PREFIX, "-button-group")
  }, buttonGroup, {
    disabled: disabled
  })));
};
exports.TimelineCardV2 = TimelineCardV2;
var NoFutureShowMilestoneCount = 2;
function computeDefaultMilestoneShowCount(milestones) {
  var total = milestones.length;
  var futureLen = milestones.filter(function (v) {
    return v.isFuture;
  }).length;
  return Math.min(futureLen === 0 ? NoFutureShowMilestoneCount : futureLen + 1, total);
}